import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ConfirmIosDonationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ConfirmIosDonationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const confirmIosDonation = (request: ConfirmIosDonationRequest, options?: CashRequestOptions) =>
  post<ConfirmIosDonationRequest, ConfirmIosDonationResponse>('/2.0/cash/confirm-ios-donation', request, {
    ...options,
    rejectOnError: true,
  })
